import ko from 'knockout';
import _ from 'lodash';
// components
import loginView from '../components/login-view/login-view';
import logoutView from '../components/logout-view/logout-view';
import loginContainerView from '../components/login-container-view/login-container-view';
import navBar from '../components/nav-bar/nav-bar';
import footerComp from '../components/footer-comp/footer-comp';
import exportModal from '../components/export-modal/export-modal';
import addalertModal from '../components/addalert-modal/addalert-modal';
import addpanelModal from '../components/addpanel-modal/addpanel-modal';
import addscheduleModal from '../components/addschedule-modal/addschedule-modal';
import orgsettingsModal from '../components/orgsettings-modal/orgsettings-modal';
import updateEndpointModal from '../components/endpoint/update-endpoint-modal';
import endpointForm from '../components/endpoint/endpoint-form/endpoint-form';
import updateTagsForm from '../components/endpoint/update-tags-form/update-tags-form';
import actionsModal from '../components/widgets/actions-modal/actions-modal';
import updateroomModal from '../components/updateroom-modal/updateroom-modal';
import shareDashboardModal from '../components/share-dashboard-modal/share-dashboard-modal';
import shareDashboardAdvModal from '../components/share-dashboard-adv-modal/share-dashboard-adv-modal';
import clearPreferencesAdvModal from '../components/clear-preferences-adv-modal/clear-preferences-adv-modal';
import updateModal from '../components/update-modal/update-modal';
// assurance views
import assuranceAppView from '../modules/assurance/views/app-shell/app-shell';
import assuranceDashboardViewDashboard from '../modules/assurance/views/dashboard/dashboard-view';
// assurance dataset views
import assuranceDatasetView from '../modules/assurance/views/dataset/dataset-view';
// capture modal
import assuranceCaptureModal from '../modules/assurance/components/capture/modal/modal';
import assuranceCallDetailsView from '../modules/assurance/views/call-details/call-details-view';
import assuranceCallDetailsContainerViews from '../modules/assurance/views/call-details/container/call-details-container-view';
// room insights views
import roomInsightsAppView from '../modules/rooms/views/app-view/rooms-app-view';

// admin view
import adminView from "../modules/admin/ko/adminView";
// dev portal
import developerPortalContainerView from '../modules/developer-portal/views/developer-portal/developer-portal-container-view';
import developerPortalView from '../modules/developer-portal/views/developer-portal/developer-portal-view';
import developerPortalDocumentationView from '../modules/developer-portal/views/developer-portal/documentation-view';
// device details views
import endpointDetailView from '../components/devicedetails/endpoint-detail-view/endpoint-detail-view';
// settings views
import settingsView from '../components/settings/settings-view';
import realtimeAlertsView from '../components/realtime/realtime-alerts-view/realtime-alerts-view';
import assuranceAlertsView from '../modules/assurance/views/moi/assurance-alerts-view';
import assuranceAlertDetailsView from '../modules/assurance/views/moi-details/alert-details-view';
// historical2 views
import historical2AppView from '../components/historical2/historical2-app-view/historical2-app-view';
import historical2DasboardView from '../components/historical2/historical2-dashboard-view/historical2-dashboard-view';
import historical2RoomboardView from '../components/historical2/historical2-dashboard-view/historical2-dashboard-view';
import historical2AdoptionView from '../components/historical2/historical2-adoption-view/historical2-adoption-view';
import historical2IssuesView from '../components/historical2/historical2-issues-view/historical2-issues-view';
import historical2CapacityView from '../components/historical2/historical2-capacity-view/historical2-capacity-view';
import historical2SchedulesView from '../components/historical2/historical2-schedules-view/historical2-schedules-view';
//  historical2 dataset views
import historical2DatasetView from '../components/historical2/historical2-dataset-view/historical2-dataset-view';

import capacityDetailsView from '../components/capacity-details-view/capacity-details-view';
// widgets
import toggleWidget from '../components/widgets/toggle-widget/toggle-widget';
import gridWidget from '../components/widgets/grid-widget/grid-widget';
import multicellWidget from '../components/widgets/multicell-widget/multicell-widget';
import typeaheadSearchgridWidget from '../components/widgets/typeahead-searchgrid-widget/typeahead-searchgrid-widget';
import searchgridWidget from '../components/widgets/searchgrid-widget/searchgrid-widget';
import searchgrid2Widget from '../components/widgets/searchgrid2-widget/searchgrid2-widget';

import loginWidget from '../components/widgets/login-widget/login-widget';
import logoutWidget from '../components/widgets/logout-widget/logout-widget';
import widgetHeader from '../components/widgets/widget-header/widget-header';
import commonWidget from '../components/widgets/common-widget/common-widget';
import daterangeWidget from '../components/widgets/daterange-widget/daterange-widget';
import webexsitesWidget from '../components/widgets/webexsites-widget/webexsites-widget';

import flexqueryWidget from '../components/widgets/flexquery-widget/flexquery-widget';
import flexomniqueryWidget from '../components/widgets/flexomniquery-widget/flexomniquery-widget';

import tabbeddashboardsWdiget from '../components/widgets/tabbeddashboards-widget/tabbeddashboards-widget';
import kpimulticellWidget from '../components/widgets/kpimulticell-widget/kpimulticell-widget';
import titleWidget from '../components/widgets/title-widget/title-widget';
import imageCaptureWidget from '../components/widgets/image-capture-widget/image-capture-widget';
import shareWidget from '../components/widgets/share-widget/share-widget';
import linkWidget from '../components/widgets/link-widget/link-widget';
import alertgridWidget from '../components/widgets/alertgrid-widget/alertgrid-widget';
import schedulegridWidget from '../components/widgets/schedulegrid-widget/schedulegrid-widget';
import scheduledmeetingsGridWidget from '../components/widgets/scheduledmeetings-grid-widget/scheduledmeetings-grid-widget';

import endpointavinfoWidget from '../components/widgets/endpointavinfo-widget/endpointavinfo-widget';
import flexigraphWidget from '../components/widgets/flexigraph-widget/flexigraph-widget';
import endpointactivecallsWidget from '../components/widgets/endpointactivecalls-widget/endpointactivecalls-widget';
import endpointhistoricalcallsWidget from '../components/widgets/endpointhistoricalcalls-widget/endpointhistoricalcalls-widget';
import flexipanelWidget from '../components/widgets/flexipanel-widget/flexipanel-widget';
import endpointcodecinfoWidget from '../components/widgets/endpointcodecinfo-widget/endpointcodecinfo-widget';
import kpicellWidget from '../components/widgets/kpicell-widget/kpicell-widget';
import kpipanelWidget from '../components/widgets/kpipanel-widget/kpipanel-widget';
import endpointnetworkinfoWidget from '../components/widgets/endpointnetworkinfo-widget/endpointnetworkinfo-widget';

import genericfiltersWidget from '../components/widgets/genericfilters-widget/genericfilters-widget';
import summarydetailWidget from '../components/widgets/summarydetail-widget/summarydetail-widget';
import historicalgraphWidget from '../components/widgets/historicalgraph-widget/historicalgraph-widget';
import historicalcapacitydetailWidget from '../components/widgets/historicalcapacitydetail-widget/historicalcapacitydetail-widget';
import mapWidget from '../components/widgets/map-widget/map-widget';
import endpointmgmtgridWidget from '../components/widgets/endpointmgmtgrid-widget/endpointmgmtgrid-widget';
import roomgridWidget from '../components/widgets/roomgrid-widget/roomgrid-widget';

import tagListWidget from '../components/widgets/tag-list-widget/tag-list-widget';
import listBuilderWidget from '../components/widgets/list-builder-widget/list-builder-widget';
// widget options
import flexipanelOptions from '../components/widget-options/flexipanel-options/flexipanel-options';
import kpicellOptions from '../components/widget-options/kpicell-options/kpicell-options';
import summarydetailOptions from '../components/widget-options/summarydetail-options/summarydetail-options';

// TODO: The below component registers itself, but the file still needs to be loaded. Is there a better place for it?
import '../modules/historical/user-details-view/container/user-details-container-view';


export default {
  registerAll: function() {
    ko.components.register('login-view', loginView);
    ko.components.register('logout-view', logoutView);
    ko.components.register('login-container-view', loginContainerView);
    ko.components.register('ko-nav-bar', navBar);
    ko.components.register('footer-comp', footerComp);
    ko.components.register('export-modal', exportModal);
    ko.components.register('addalert-modal', addalertModal);
    ko.components.register('addpanel-modal', addpanelModal);
    ko.components.register('addschedule-modal', addscheduleModal);
    ko.components.register('orgsettings-modal', orgsettingsModal);
    ko.components.register('update-endpoint-modal', updateEndpointModal);
    ko.components.register('endpoint-form', endpointForm);
    ko.components.register('update-tags-form', updateTagsForm);
    ko.components.register('actions-modal', actionsModal);
    ko.components.register('updateroom-modal', updateroomModal);
    ko.components.register('share-dashboard-modal', shareDashboardModal);
    ko.components.register('share-dashboard-adv-modal', shareDashboardAdvModal);
    ko.components.register('clear-preferences-adv-modal', clearPreferencesAdvModal);
    ko.components.register('update-modal', updateModal);

    // ASSURANCE VIEWS
    ko.components.register('assurance-app-view', assuranceAppView);
    ko.components.register('assurance-dashboard-view-dashboard', assuranceDashboardViewDashboard);

    var assuranceDatasetViews = [
      'systems',
      'endpoints',
      'meetings',
      'calls',
      'trunks',
      'events',
      'spaces',
      'buildings',
      'networks',
      'sensors'
    ];
    _.forEach(assuranceDatasetViews, function(viewName) {
      ko.components.register(
        'assurance-dataset-view-' + viewName,
        assuranceDatasetView
      );
    });

    ko.components.register(
      'historical2-dataset',
      assuranceDatasetView
    );

    //  capture modal (component helper)
    ko.components.register('assurance-capture-modal', assuranceCaptureModal);
    ko.components.register('assurance-call-details-view', assuranceCallDetailsView);
    ko.components.register('assurance-call-details-container-view', assuranceCallDetailsContainerViews);

    // ROOM INSIGHTS STAND-ALONE VIEWS
    ko.components.register('rooms-app-view', roomInsightsAppView);

    //  dev portal
    ko.components.register('developer-portal-container-view', developerPortalContainerView);
    ko.components.register('developer-portal-view', developerPortalView);
    ko.components.register('developer-documentation-view', developerPortalDocumentationView);

    // DEVICE DETAILS VIEWS
    ko.components.register('endpoint-detail-view', endpointDetailView);

    // SETTINGS VIEWS
    ko.components.register('settings-view', settingsView);
    ko.components.register('realtime-alerts-view', realtimeAlertsView);
    ko.components.register('assurance-alerts-view', assuranceAlertsView);
    ko.components.register('assurance-alert-details-view', assuranceAlertDetailsView);

    // HISTORICAL 2 (NON LOGI) VIEWS
    ko.components.register('historical2-app-view', historical2AppView);
    ko.components.register('historical2-dashboard-view', historical2DasboardView);
    ko.components.register('historical2-roomboard-view', historical2RoomboardView);
    ko.components.register('historical2-adoption-view', historical2AdoptionView);
    ko.components.register('historical2-issues-view', historical2IssuesView);
    ko.components.register('historical2-capacity-view', historical2CapacityView);
    ko.components.register('historical2-schedules-view', historical2SchedulesView);

    //  patch so routes/content work as expected :: c.f.: UI-1316
    var aaDatasetViews = [
      'endpoints',
      'infrastructure',
      'meetings',
      'rooms',
      'bookings',
      'user',
      'networks'
    ];
    _.forEach(aaDatasetViews, function(viewName) {
      ko.components.register(
        'historical2-dataset-view-' + viewName,
        historical2DatasetView
      );
    });

    ko.components.register('capacity-details-view', capacityDetailsView);

    // WIDGETS (grouped in 10s for easier counting)
    ko.components.register('toggle-widget', toggleWidget);
    ko.components.register('grid-widget', gridWidget);
    ko.components.register('multicell-widget', multicellWidget);
    ko.components.register('typeahead-searchgrid-widget', typeaheadSearchgridWidget);
    ko.components.register('searchgrid-widget', searchgridWidget);
    ko.components.register('searchgrid2-widget', searchgrid2Widget);

    ko.components.register('login-widget', loginWidget);
    ko.components.register('logout-widget', logoutWidget);
    ko.components.register('widget-header', widgetHeader);
    ko.components.register('common-widget', commonWidget);
    ko.components.register('daterange-widget', daterangeWidget);
    ko.components.register('webexsites-widget', webexsitesWidget);

    ko.components.register('flexquery-widget', flexqueryWidget);
    ko.components.register('flexomniquery-widget', flexomniqueryWidget);

    ko.components.register('tabbeddashboards-widget', tabbeddashboardsWdiget);
    ko.components.register('kpimulticell-widget', kpimulticellWidget);
    ko.components.register('title-widget', titleWidget);
    ko.components.register('image-capture-widget', imageCaptureWidget);
    ko.components.register('share-widget', shareWidget);
    ko.components.register('link-widget', linkWidget);
    ko.components.register('alertgrid-widget', alertgridWidget);
    ko.components.register('schedulegrid-widget', schedulegridWidget);
    ko.components.register('scheduledmeetings-grid-widget', scheduledmeetingsGridWidget);

    ko.components.register('endpointavinfo-widget', endpointavinfoWidget);
    ko.components.register('flexigraph-widget', flexigraphWidget);
    ko.components.register('endpointactivecalls-widget', endpointactivecallsWidget);
    ko.components.register('endpointhistoricalcalls-widget', endpointhistoricalcallsWidget);
    ko.components.register('flexipanel-widget', flexipanelWidget);
    ko.components.register('endpointcodecinfo-widget', endpointcodecinfoWidget);
    ko.components.register('kpicell-widget', kpicellWidget);
    ko.components.register('kpipanel-widget', kpipanelWidget);
    ko.components.register('endpointnetworkinfo-widget', endpointnetworkinfoWidget);

    ko.components.register('genericfilters-widget', genericfiltersWidget);
    ko.components.register('summarydetail-widget', summarydetailWidget);
    ko.components.register('historicalgraph-widget', historicalgraphWidget);
    ko.components.register('historicalcapacitydetail-widget', historicalcapacitydetailWidget);
    ko.components.register('map-widget', mapWidget);
    ko.components.register('endpointmgmtgrid-widget', endpointmgmtgridWidget);
    ko.components.register('roomgrid-widget', roomgridWidget);

    ko.components.register('tag-list-widget', tagListWidget);
    ko.components.register('list-builder-widget', listBuilderWidget);


    // WIDGET OPTIONS
    ko.components.register('flexipanel-options', flexipanelOptions);
    ko.components.register('kpicell-options', kpicellOptions);
    ko.components.register('summarydetail-options', summarydetailOptions);
  }
};
